import { AGGREGATE_NAMES, LOAN_REQUEST_RESOLVERS, USER_RESOLVERS } from 'cpool-constants';
import type { OfferFilter } from 'cpool-schemas';
import {
    schemaLoanRequestResolver_GetAcceptedOffers,
    schemaUserResolver_GetAclPermissions,
} from 'cpool-tables/backend-resolvers';
import type { z } from 'zod';

import { getQueryOptions } from '~/queryUtils/getQueryOptions';

export const aclPermissionsQueryOptions = (leadId?: string) =>
    getQueryOptions({
        aggregateName: AGGREGATE_NAMES.USER,
        resolverName: USER_RESOLVERS.getAclPermissions,
        schema: schemaUserResolver_GetAclPermissions,
        searchParams: { loanRequestId: leadId },
    });

export const acceptedOffersQueryOptions = ({
    filter,
    leadId,
}: {
    filter?: z.infer<typeof OfferFilter>;
    leadId: string;
}) =>
    getQueryOptions({
        aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
        resolverName: LOAN_REQUEST_RESOLVERS.getAcceptedOffers,
        schema: schemaLoanRequestResolver_GetAcceptedOffers,
        searchParams: {
            filter: filter ?? {},
            id: leadId,
        },
    });
